import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from "@mui/material";
import useAuth from "../../../../auth/useAuth";
import { useFetchGET } from "../../../../state/FetchHelpers";
import { ruteoDriversListRoute } from "../../../../config";

const ApproveRouteDialog = ({ open, onClose, onConfirm, creationDate }) => {
  const auth = useAuth();
  const token = auth.globals.token;

  const [driverId, setDriverId] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const { data: driversResponse, loading: driversLoading } = useFetchGET(
    open ? ruteoDriversListRoute(creationDate) : undefined,
    token,
    []
  );

  const driversListData = Array.isArray(driversResponse?.drivers) ? driversResponse.drivers : [];

  useEffect(() => {
    if (open) setDriverId("");
  }, [open]);

  const handleConfirm = async () => {
    if (!driverId) return;
    setSubmitting(true);
    await onConfirm(driverId);
    setSubmitting(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Aprobar y asignar ruta</DialogTitle>
      <DialogContent>
        {driversLoading ? (
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <FormControl fullWidth variant="filled" sx={{ mt: 1 }}>
            <InputLabel id="select-route-driver-label">Driver</InputLabel>
            <Select
              labelId="select-route-driver-label"
              value={driverId}
              onChange={(e) => setDriverId(e.target.value)}
              size="small"
            >
              {driversListData.map((driver) => (
                <MenuItem key={driver.id} value={driver.id}>
                  {driver.name} {driver.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="secondary"
          disabled={!driverId || submitting}
        >
          {submitting ? <CircularProgress size={20} color="inherit" /> : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveRouteDialog;
